import React from "react";
import { Image, Modal, Space } from "antd";
import { Messages } from "../Common/ValidateMessages";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { rubricScoringPatternType } from "../Common/AppSettings";

const { confirm } = Modal;

interface Props {
  value?: string;
  onChange?: (value?: string) => void;
  haveEvaluationViewpoints: boolean;
  studentCount: string;
}

export const ScorePatternRadioGroup = ({
  value,
  onChange,
  haveEvaluationViewpoints,
  studentCount,
}: Props) => {
  const [previewVisible, setPreviewVisible] = React.useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [radioValue, setRadioValue] = React.useState(value);

  React.useEffect(() => {
    setRadioValue(value);
    // onChange?.(value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, studentCount]);

  const onDataChange = (e) => {
    // console.log(newValue);
    if (e.target.checked) {
      if (haveEvaluationViewpoints) {
        confirm({
          title: Messages["CON-007"],
          icon: <ExclamationCircleOutlined />,
          onOk: () => {
            setRadioValue(e.target.value);
            onChange?.(e.target.value);
          },
          onCancel: () => {
            e.preventDefault();
          },
          okText: "はい",
          cancelText: "いいえ",
        });
      } else {
        setRadioValue(e.target.value);
        onChange?.(e.target.value);
      }
    }
  };

  const radioGroups: any[] = [];
  for (let i = 1; i <= 9; i++) {
    let disable = false;
    if (studentCount === "0") {
      if (i === 3 || i === 5 || i === 8) {
        disable = true;
      } else {
        disable = false;
      }
    } else {
      if (i === 3 || i === 5 || i === 8) {
        disable = false;
      } else {
        disable = true;
      }
    }
    radioGroups.push(
      <Space key={i} direction="vertical">
        <div>
          ({i}){rubricScoringPatternType[i]}
        </div>
        <div>
          <input
            disabled={disable}
            id={`pattern${i}`}
            type="radio"
            name="scorePattern"
            value={`${i}`}
            checked={radioValue === `${i}`}
            onChange={(e) => onDataChange(e)}
            style={{ width: "0px" }}
          />
          <label
            className={
              disable
                ? `drinkcard-cc-disabled can-not-use-pattern`
                : `drinkcard-cc score-pattern${i}`
            }
            htmlFor={`pattern${i}`}
            onDoubleClick={(e) => {
              if (!disable) {
                const newvalues: boolean[] = [
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                  false,
                ];
                newvalues[i - 1] = true;
                setPreviewVisible(newvalues);
              }
            }}
          ></label>
          <Image
            style={{ display: "none" }}
            src={`/img/pattern_${i}.png`}
            preview={{
              visible: previewVisible[i - 1],
              src: `/img/pattern_${i}.png`,
              onVisibleChange: (value) => {
                if (!value) {
                  const newvalues: boolean[] = [
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                    false,
                  ];
                  newvalues[i - 1] = value;
                  setPreviewVisible(newvalues);
                }
              },
            }}
          />
        </div>
      </Space>
    );
  }

  return (
    <Space className="pattern-selector" size={40} wrap>
      {radioGroups}
    </Space>
  );
};
